export const ADDRESS_COMPONENTS = {
    POSTAL_CODE: 'postal_code',
    LOCALITY: { primary: 'locality', additional: ['administrative_area_level_1'] },
    REGION: 'administrative_area_level_1',
    STREET: { primary: 'route', additional: ['point_of_interest','establishment'] },
    COUNTRY: 'country',
    STREET_NUMBER: 'street_number'
}



// WEBPACK FOOTER //
// ./src/constants/geocoder.ts